import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { ArchivedNotificationsRouterModule } from './archived-notifications.routes';
import { ArchivedNotificationViewerComponent } from './components/archived-notification-viewer.component';
import { ArchivedNotificationView } from './views/archived-notifications/archived-notifications.view';

@NgModule({
    declarations: [ArchivedNotificationView, ArchivedNotificationViewerComponent],
    imports: [CommonModule, ArchivedNotificationsRouterModule, AppCommonModule, PlatformModule],
})
export class ArchivedNotificationsModule {}
